import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { RevealGroup, RevealItem } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { serviceOverview } from "@/data/content";

export default function ServicesOverview() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="services-overview">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="What We Do"
          title="Everything Your Property Needs to Grow Online"
          subtitle="Practical hospitality and digital solutions, tailored to your property's size, location and goals."
        />
        <RevealGroup className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {serviceOverview.map((s) => (
            <RevealItem key={s.title}>
              <Link
                to="/services"
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex h-full flex-col rounded-2xl border border-line bg-white p-8 shadow-float transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-float-lg"
              >
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-navy text-sky transition-colors duration-300 group-hover:bg-ocean group-hover:text-white">
                  <Icon name={s.icon} className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-serif text-xl font-semibold text-navy">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-ocean">
                  Learn More
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
